import { Modal } from "@/components/ui/modal";
import { Button } from "@/components/ui/button";
import ItineraryStep from "@/lib/builder/ItineraryStep";
import { StepProps } from "@/lib/builder/models/builder.model";

interface ItineraryStepModalProps extends Pick<StepProps, 'data' | 'onDataChange' | 'canProceed' | 'setCanProceed' | 'isReadOnly'> {
  isOpen: boolean;
  onClose: () => void;
}

export const ItineraryStepModal = ({
  isOpen,
  onClose,
  data,
  onDataChange,
  canProceed,
  setCanProceed,
  isReadOnly,
}: ItineraryStepModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Itinerary Details"
      size="lg"
      footer={
        <div className="flex w-full justify-end">
          <Button onClick={onClose}>Confirm</Button>
        </div>
      }
    >
      <div className="overflow-y-auto">
        {data && (
          <ItineraryStep
            data={data}
            onDataChange={onDataChange}
            onNext={onClose}
            onPrevious={() => {}}
            onSave={() => {}}
            onCancel={onClose}
            canProceed={canProceed}
            setCanProceed={setCanProceed}
            isReadOnly={isReadOnly}
            compact
          />
        )}
      </div>
    </Modal>
  );
};
